import React from 'react'
import { Outlet } from 'react-router-dom'

const Web3WithdrawComponent = () => {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default Web3WithdrawComponent
